/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DictionaryResponse } from './dictionary-response';


export interface SearchUserResponseItem { 
    id: string;
    fullName: string;
    telegramLogin: string;
    email: string;
    roleName: string;
    lastLoginDate?: string | null;
    status: DictionaryResponse;
}

